/* eslint-disable max-classes-per-file */
import React from 'react';
import { faClone, faEdit, faEye, faList, faLock, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col } from 'react-bootstrap';

import Popup from 'reactjs-popup';
import ShadeForm from './ShadeActions/ShadeForm.js';
import ShadePriceBreakdown from './ShadeActions/ShadePriceBreakdown';
// import ShadeForm from '../ShadeForm/ShadeForm';

import ServiceAssembly from './ShadeActions/ServiceAssembly';
import Button from '../../Parts/Button';
import { store } from '../../Store/configureStore.ts';
import { selectMotors, selectTubes } from '../../Store/entities/parts/hooks.ts';
import HeaderData from '../NewItems/HeaderData.js';

// TODO LIST:
// ! Convert Class to Function Component
// ! Convert to Typescript

class ShadeActions extends React.Component {
	constructor(props) {
		super(props);

		const { isEditable } = props;

		this.props = props;

		this.state = {
			isEditable,
		};

		this.ChangeList = [];

		this.onChange = this.onChange.bind(this);
		this.deleteAssembly = this.deleteAssembly.bind(this);
		this.done = this.done.bind(this);
		this._partsFetched = false;
	}

	onChange(args) {
		// This is where we cache everything
		this.ChangeList.push(args);
	}

	done() {
		// Do saving
		this.ChangeList.forEach((c) => {
			// Save
		});

		this.props.Data.UI.reRenderTable(true);

		this.props.onDone && this.props.onDone();
	}

	deleteAssembly() {
		const self = this;
		const seqId = self.props.sequenceId;
		const seqIdToShadeName = self.props.Data.shadeSubstitute(seqId).val('shade_name');
		ROOT.alert({
			title: 'Are you sure you want to delete this shade?',
			text: `You are about to delete ${seqIdToShadeName}! There's no way to undo this.`,
			icon: 'warning',
			quoteType: this.props.quoteType.toLowerCase(),
		})
			.then(() => {
				self.props.Data.deleteAssembly(seqId);
				ROOT.toast(`${seqIdToShadeName} deleted`, {
					type: 'success',
					duration: 8000,
				});
			})
			.catch(() => {
				ROOT.toast(`Deletion of ${seqIdToShadeName} canceled`, {
					type: 'info',
					duration: 3000,
				});
			});
	}

	render() {
		const { quote } = this.props.quoteData.oldObjects;

		const buttons = [];

		const shade = this.props.quoteData.shadeSubstitute(this.props.sequenceId);

		const shadeName = shade.val('shade_name');

		const { quoteData } = this.props;
		const quoteType = this.props.quoteType.toLowerCase();

		if (this.state.isEditable) {
			buttons.push(
				<Popup
					key="edit"
					trigger={
						<Col>
							<Button fullWidth color="light" size="sm" hoverColor={quoteType}>
								<FontAwesomeIcon icon={faEdit} />
							</Button>
						</Col>
					}
					modal
					nested
				>
					{(close) => (
						<div>
							<div id="product-editor">
								<div className="product-form">
									<h2 className={`text-${quoteType}`}>Edit Shade</h2>
									<ShadeForm
										quoteType={quoteType}
										onOptionBlur={quote.shadesUpdated}
										shade={shade}
										quote={quote}
										onChange={this.onChange}
										quoteData={quoteData}
									/>
									<Container className="local-bootstrap">
										<Row className="justify-content-center">
											<Col lg={4}>
												<Button
													color={quoteType ?? 'green'}
													fullWidth
													onClick={() => {
														close();
														this.done();
													}}
												>
													Done
												</Button>
											</Col>
										</Row>
										{shade.isUnlocked() ? null : (
											<Row className="justify-content-center mt-2">
												<Col lg={4}>
													<Button
														fullWidth
														color={quoteType ?? 'green'}
														onClick={() => {
															shade.unlock();
														}}
													>
														<FontAwesomeIcon
															transform="grow-5"
															icon={faLock}
														/>
													</Button>
												</Col>
											</Row>
										)}
									</Container>
								</div>
							</div>
						</div>
					)}
				</Popup>
			);

			buttons.push(
				<Col>
					<Button
						size="sm"
						color="light"
						fullWidth
						key="duplicate"
						title="Duplicate"
						hoverColor={quoteType}
						onClick={() => {
							const seqIdToShadeName = this.props.Data.shadeSubstitute(
								this.props.sequenceId
							).val('shade_name');
							quoteData.DuplicateShade(this.props.sequenceId);
							ROOT.toast(`Duplicated ${seqIdToShadeName}`, {
								type: 'success',
								duration: 2000,
							});
						}}
					>
						<FontAwesomeIcon icon={faClone} />
					</Button>
				</Col>
			);

			buttons.push(
				<Col>
					<Button
						fullWidth
						color="light"
						size="sm"
						hoverColor={quoteType}
						key="delete"
						title="Delete"
						onClick={this.deleteAssembly}
					>
						<FontAwesomeIcon icon={faTrashAlt} />
					</Button>
				</Col>
			);
		}

		buttons.push(
			<Popup
				key="summary"
				color="light"
				trigger={(
					<Col>
						<Button
							fullWidth
							color="light"
							size="sm"
							hoverColor={quoteType}
							title="Summary"
						>
							<FontAwesomeIcon icon={faEye} />
						</Button>
					</Col>
				)}
				modal
				nested
			>
				{(close) => {
					const displayItems = [];

					const shadeData = shade?.data() ?? {};

					const ignoredFields = [
						'cost',
						'base_sale_price',
						'dealer_sale_price',
						'api_motor_id',
						'hidden_shipping',
						'ShadesCost',
						'ShadesMsrp',
						'tube_name'
					];

					const specialFields = [
						{
							varName: 'header_type',
							action: (shadeData) => {
								const headerType = HeaderData().find(
									(i) => i.value == shadeData.header_type
								);

								return headerType?.name ?? shadeData.header_type;
							},
						},
						{
							varName: 'motor',
							action: (shadeData, shade, specifcShadeData) => {
								let { motor } = specifcShadeData;
								// Motor Name Substitution.
								if (motor == 'DM35CEQ/S-2/28') {
									motor = '35 mm 12VDC Hardwired Motor';
								} else if (motor == 'DM35LEQ/S-2/28') {
									motor = '35 mm Li-Ion RF Motor';
								}
								return motor;
							},
						},
					];

					let sd_index = 0;
					for (const sd in shadeData) {
						if (sd == 'shades' || ignoredFields.includes(sd)) {
							continue;
						}

						const special = specialFields.find((sf) => sf.varName == sd);

						const value = special ? special.action(shadeData, shade) : shadeData[sd];
						sd_index++;
						displayItems.push(
							<tr key={`sd-${sd_index}`}>
								<th>
									{sd}
									:
									{' '}
								</th>
								<td>{value}</td>
							</tr>
						);
					}

					shadeData?.shades?.forEach((s) => {
						displayItems.push(
							<tr key={`${s.row_coordinate}-${s.column_coordinate}`}>
								<th>
									<h4>
										Shade Row
										{' '}
										{s.row_coordinate}
										{' '}
										Column
										{' '}
										{s.column_coordinate}
									</h4>
								</th>
							</tr>
						);

						let s_index = 0;

						for (const sKey in s) {
							if (ignoredFields.includes(sKey)) continue;

							const special = specialFields.find((sf) => sf.varName == sKey);

							const value = special ? special.action(shadeData, shade, s) : s[sKey];

							s_index++;

							displayItems.push(
								<tr key={`s-${s_index}`}>
									<th>
										{sKey}
										:
										{' '}
									</th>
									<td>{value}</td>
								</tr>
							);
						}
					});

					return (
						<div id="product-editor">
							<div className="product-form">
								<div style={{ overflowX: 'auto' }}>
									<h2 className={`text-${quoteType}`}>
										Summary for Shade: {shadeName}
									</h2>
									<table className="minimalistic-table">
										<tbody>{displayItems}</tbody>
									</table>
									{!shadeData.error_messages ? null : (
										<>
											<h3 className="error shade-errors">Errors</h3>
											<h4 className="error shade-errors">
												{shadeData.error_messages}
											</h4>
										</>
									)}
									<Container className="local-bootstrap">
										<Row className="justify-content-center mt-2">
											<Col lg={4}>
												<Button
													color={quoteType ?? 'green'}
													fullWidth
													onClick={() => {
														close();
														this.done();
													}}
												>
													Done
												</Button>
											</Col>
										</Row>
									</Container>
								</div>
							</div>
						</div>
					);
				}}
			</Popup>
		);
		// Add ShadeSummary
		// Add PriceBreakdown
		if (this.props.isAdmin) {
			buttons.push(
				<Popup
					className="mobile-modal"
					key="price-breakdown"
					trigger={(
						<Col>
							<Button
								fullWidth
								color="light"
								size="sm"
								title="Price Breakdown"
								hoverColor={quoteType}
							>
								<FontAwesomeIcon icon={faList} />
							</Button>
						</Col>
					)}
					modal
					nested
				>
					{(close) => (
						<ShadePriceBreakdown
							quoteType={quoteType}
							sequenceId={shade.sequenceId}
							quoteData={quoteData}
							done={close}
						/>
					)}
				</Popup>
			);
		}
		
		if (this.props.hasServiceAccess) {
			buttons.push(
				<ServiceAssembly
					SetShadeToBeMadeFunction={(value, row, column) => quoteData.SetShadeToBeMade(this.props.sequenceId, value, row, column)}
					SetFabricToBeCut={(value) => quoteData.SetFabricToBeCut(this.props.sequenceId, value)}
					SetHeaderExtrusionToBeCut={(value) =>
						quoteData.SetHeaderExtrusionToBeCut(this.props.sequenceId, value)
					}
					SetHembarToBeCut={(value) => quoteData.SetHembarToBeCut(this.props.sequenceId, value)}
					SetSideChannelsToBeCut={(value) => quoteData.SetSideChannelsToBeCut(this.props.sequenceId, value)}
					SetSillChannelsToBeCut={(value) => quoteData.SetSillChannelsToBeCut(this.props.sequenceId, value)}
					SetTubeToBeCut={(value) => quoteData.SetTubeToBeCut(this.props.sequenceId, value)}
					quoteType={quoteType}
					key={shade.sequenceId}
					assembly={shade.data()}
					SetIsMotorOnly={(value) => quoteData.SetIsMotorOnly(this.props.sequenceId, value)}
					SetIsChannelsOnly={(value) => quoteData.SetIsChannelsOnly(this.props.sequenceId, value)}
					SetRecipeSku={(value) => quoteData.SetRecipeSku(this.props.sequenceId, value)}
					SetIsTubeAndFabricOnly={(value) => quoteData.SetIsTubeAndFabricOnly(this.props.sequenceId, value)}
					SetIsHeaderExtrusionOnly={(value) =>
						quoteData.SetIsHeaderExtrusionOnly(this.props.sequenceId, value)
					}
					SetIsHardwareOnly={(value) => quoteData.SetIsHardwareOnly(this.props.sequenceId, value)}
					SetIsShadeService={(value) => quoteData.SetIsShadeService(this.props.sequenceId, value)}
					tubes={this.state.tubes}
					motors={this.state.motors}
					SetTubeOverride={(value) => quoteData.SetTubeOverride(this.props.sequenceId, value)}
					SetMotorOverride={(value) => quoteData.SetMotorOverride(this.props.sequenceId, value)}
					SetIsCrownAndDriveOnly={(value) => quoteData.SetIsCrownAndDriveOnly(this.props.sequenceId, value)}
					previousQuoteId={quoteData.quote.previous_quote_id}
				/>
			);
		}
		return (
			<Container className="local-bootstrap">
				<Row className="justify-content-between g-0">{buttons}</Row>
			</Container>
		);
	}
}

export default ShadeActions;
